import { Controller } from "stimulus"

export default class extends Controller {
  connect(){
    // prevent enter new line 
    this.element.addEventListener('keypress', function(event) {
      if (event.keyCode == 13) {
        event.preventDefault();
      }
    });

    // auto scroll height during typing text
    this.element.addEventListener('input', function(event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + 'px';
    });

    // on click cell table show all text
    this.element.addEventListener('click',function(event) {
      event.target.style.height = event.target.scrollHeight + 'px';
    });
  }
}